import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useLoanStore } from "@roc/feature-loans";
import { useUserStore } from "@roc/feature-app-core";
import { VirtualScroll } from "./components/common/virtualScroll";
import { LoanPricingTab } from "./tabs/pricingTab";
import { Box } from "@material-ui/core";

export const PricingTabInternal = observer(() => {
  const { loanStore } = useLoanStore();
  const { userStore } = useUserStore();
  const { loanId } = useParams<{ loanId: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const numericLoanId = Number(loanId);


  const fetchLoanDetails = async () => {
    if (!numericLoanId) return;
    await loanStore.fetchLoanDetails(numericLoanId, () => {
      setIsLoading(false);
    });
  };

  useEffect(() => {
    userStore.getUserInfoAndEntitlements();
  }, [userStore]);

  useEffect(() => {
    if (!numericLoanId) return;
    fetchLoanDetails();
  }, [loanStore, numericLoanId]);
  return isLoading ? (<div>Loading...</div>) : (
    <VirtualScroll>
      <Box style={{ maxHeight: '970px', overflowY: 'auto' }}>
        <LoanPricingTab source={userStore.isNportalUser ? 'nportal' : 'cportal'} />
      </Box>
    </VirtualScroll>
    );
});
